import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import styles from './Media.module.css'


const Play = (props: any) => {
    const { handleClick } = props;

    return (
        <button className={styles.playerButton} onClick={handleClick}>
            <FontAwesomeIcon icon={faPlay} />
        </button>
    );
}

export default Play
